import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    active: { type: String, default: "0" }
  }

  connect() {
    this.showTab(this.activeValue)
  }

  switch(event) {
    event.preventDefault()
    const index = event.currentTarget.dataset.tabsIndex
    this.activeValue = index
    this.showTab(index)
  }

  showTab(index) {
    this.tabTargets.forEach((tab) => {
      if (tab.dataset.tabsIndex === index) {
        tab.classList.add("border-[#000000]")
        tab.classList.remove("border-transparent")
      } else {
        tab.classList.remove("border-[#000000]")
        tab.classList.add("border-transparent")
      }
    })

    this.panelTargets.forEach((panel) => {
      if (panel.dataset.tabsIndex === index) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }
}
